import React from 'react';
import { Form, FormGroup } from "reactstrap";
import InputCustom from "../../../../components/InputCustom";
import LoadingButton from "../../../../components/LoadingButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/pro-solid-svg-icons";
import { Link } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";

const PasswordResetForm = ({ intl, values, isLoading, isSuccess, resetFailed, handleChange, handleSubmit }) => {
  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup>
        <InputCustom
          required
          id="login-username"
          name="email"
          type="email"
          value={values.email}
          onChange={handleChange}
          placeHolder={intl.formatMessage({ id: 'ResetPassword.email' })}
        />
      </FormGroup>

      <div className="text-center">
        <LoadingButton
          isLoading={isLoading}
          isSucceed={isSuccess}
          isFailed={resetFailed}
          value="ResetPassword.reset"
          type="submit"
          className="btn btn-outline-light btn-block btn-login"
        />
      </div>
      <div className="mt-2 text-center">
        <Link to="login" className="text-white">
          <FontAwesomeIcon icon={faArrowLeft} className="mr-1" />
          <FormattedMessage id="ResetPassword.back" />
        </Link>
      </div>
    </Form>
  );
};

export default injectIntl(PasswordResetForm);
